import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import circuit from "images/circuit diagram left.svg";
import styled from "styled-components";
import Hero from "components/hero/TwoColumnWithFeaturesAndTestimonial.js";
import Features from "components/features/ThreeColWithSideImage.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import TeamCardGrid from "components/cards/ProfileThreeColGrid.js";
const Decorator = ({ className }) => (
  <img src={circuit} className={className} />
);

const DecoratedBlob = styled(Decorator)`
  ${tw`hidden lg:flex`}

  left: 0;
  position: absolute;
  top: -400px;
  margin: -30px;
  width: 900px;
  opacity: 0.1;
`;
const HighlightedText = tw.span`text-primary-500`;
const Subheading = tw.span`uppercase tracking-wider text-sm`;
export default () => {
  return (
    <>
      <Hero />
      <a id="services" />
      <AnimationRevealPage>
        <Features />
      </AnimationRevealPage>
      <a id="team" />
      <div style={{ position: "relative", overflow: "visible" }}>
        <DecoratedBlob />
      </div>
      <AnimationRevealPage>
        <TeamCardGrid subheading={<Subheading>Our Team</Subheading>} />
      </AnimationRevealPage>
      <a id="contact" />
      <AnimationRevealPage>
        <Footer />
      </AnimationRevealPage>
    </>
  );
};
